module.exports = __webpack_public_path__ + "assets/textures/violin_tex_AO.6b3a55798d390b25672290c85d11821b.jpg";